module.exports = __webpack_public_path__ + "media/images/lb/343-2a22c70426c118d757c88e3fbe127279.svg";